import { get } from "lodash-es";
import moment from "moment";
import {
	MESApiService,
	type spParameter,
} from "../../../../services/ApiService";
import { Job } from "../models/Job";

//const moment = getMomentTz();

export const getJobs = async (signal?: AbortSignal) => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2("[SYSTEM].[GetJobsStatus]", [], signal);

	if (resp.ok) {
		let rows = get(resp, "data.tables[0].rows", []);

		rows = rows.map((job: Job) => ({
			...job,
			LastStarted: job.LastStarted
				? moment.utc(job["LastStarted"]).toDate()
				: null,
			LastContact: job.LastContact
				? moment.utc(job["LastContact"]).toDate()
				: null,
			LastCounter: job.LastCounter
				? moment.utc(job["LastCounter"]).toDate()
				: null,
			StartTime: job.StartTime ? moment.utc(job["StartTime"]).toDate() : null,
			NextExecutionTime: job.NextExecutionTime
				? moment.utc(job["NextExecutionTime"]).toDate()
				: null,
			LastExecutionTime: job.LastExecutionTime
				? moment.utc(job["LastExecutionTime"]).toDate()
				: null,
		}));

		return rows as Job[];
	} else {
		throw new Error(resp.message || "Error fetching jobs");
	}
};

export const upsertJob = async (job: Job) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "JobId", value: job.JobId },
		{ name: "sProcedure", value: job.sProcedure },
		{ name: "StartTime", value: job.StartTime },
		{ name: "PeriodTime", value: job.PeriodTime },
		{ name: "RestartAfterFailure", value: job.RestartAfterFailure },
	];

	const resp = await apiService.callV2("[SYSTEM].[UpsertJob]", parameters);

	if (resp.ok) {
		return get(resp, "data.returnValue", null) as number;
	} else {
		throw new Error(resp.message || "Error when upsert job");
	}
};

export const setJobEnable = async ({
	enabled,
	jobId,
}: {
	enabled: boolean | null;
	jobId: number | null;
}) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "Enabled", value: enabled ?? true },
		{ name: "JobId", value: jobId },
	];

	const resp = await apiService.callV2("[SYSTEM].[SetJobEnable]", parameters);

	if (!resp.ok) {
		throw new Error(resp.message || "Error when enable job");
	}
};

export const restartJob = async (jobId: number | null) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [{ name: "JobId", value: jobId }];

	const resp = await apiService.callV2("[SYSTEM].[RestartJob]", parameters);

	if (!resp.ok) {
		throw new Error(resp.message || "Error when restart job");
	}
};
